import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const cboSchema: Schema = {
  title: 'CBO Statistics Gathering',
  level: 2,
  columns: commonColumns
}
